export const legalPages = {
  "/mentions-legales": {
    title: "Mentions légales",
    intro: "Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique et à la loi Hoguet n° 70-9 du 2 janvier 1970.",
    sections: [
      {
        h: "Éditeur du site",
        p: [
          "Loyaris est une marque exploitée par Gestion Locative Plus — SAS au capital social de 3 000 €",
          "Siège social : 128, rue la Boétie, 75008 Paris",
          "Agence : 38, rue Jean Pierre Timbaud, 92130 Issy-les-Moulineaux",
          "R.C.S. Paris 793 593 567 — SIRET : 793 593 567 00035",
          "Email : contact@loyaris.fr",
        ],
      },
      {
        h: "Carte professionnelle et garantie financière",
        p: [
          "Carte professionnelle « Transactions sur immeubles et fonds de commerce » et « Gestion immobilière », délivrée par la CCI Paris-Île-de-France, numéro CPI 7501 2020 000 045 562.",
          "Garantie financière de 520 000 €, délivrée par GALIAN.",
          "Le titulaire de la carte ne peut recevoir aucun fonds, effet ou valeur en dehors de ceux couverts par la garantie financière.",
        ],
      },
      {
        h: "Directeur de la publication",
        p: ["Le représentant légal de Gestion Locative Plus."],
      },
      {
        h: "Hébergement",
        p: ["Ce site est hébergé sur une infrastructure cloud sécurisée. Les coordonnées complètes de l'hébergeur sont disponibles sur simple demande à contact@loyaris.fr."],
      },
      {
        h: "Propriété intellectuelle",
        p: ["L'ensemble des contenus du site (textes, visuels, identité graphique) est la propriété exclusive de Gestion Locative Plus. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable."],
      },
      {
        h: "Responsabilité",
        p: ["Les informations diffusées sur ce site, notamment l'estimation en ligne des loyers et des frais de gestion, sont fournies à titre indicatif et ne constituent ni un devis ni un engagement contractuel. Seul un mandat de gestion signé définit les conditions applicables."],
      },
    ],
  },
  "/confidentialite": {
    title: "Politique de confidentialité",
    intro: "Loyaris attache une grande importance à la protection de vos données personnelles, traitées conformément au Règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés.",
    sections: [
      {
        h: "Responsable du traitement",
        p: ["Gestion Locative Plus (marque Loyaris), SAS — 128, rue la Boétie, 75008 Paris — contact@loyaris.fr"],
      },
      {
        h: "Données collectées",
        p: [
          "Formulaire de contact : nom, email, téléphone (facultatif), message et page d'origine.",
          "Simulateur d'estimation : caractéristiques du bien (localisation, type, surface, état) et résultat, sans donnée d'identification.",
          "Sécurité : l'adresse IP est conservée au maximum une heure pour limiter les envois abusifs.",
        ],
      },
      {
        h: "Finalités et base légale",
        p: [
          "Répondre à vos demandes et vous présenter nos offres de gestion locative (mesures précontractuelles prises à votre demande).",
          "Améliorer nos estimations de loyer et protéger le site contre le spam (intérêt légitime).",
        ],
      },
      {
        h: "Durée de conservation",
        p: ["Les demandes de contact sont conservées 3 ans à compter du dernier échange, puis supprimées, sauf relation contractuelle en cours."],
      },
      {
        h: "Destinataires",
        p: ["Vos données sont destinées exclusivement aux équipes de Gestion Locative Plus (Loyaris) et ne sont ni vendues ni cédées à des tiers."],
      },
      {
        h: "Cookies",
        p: ["Ce site n'utilise aucun cookie publicitaire ni de mesure d'audience."],
      },
      {
        h: "Vos droits",
        p: [
          "Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation et de portabilité de vos données. Pour l'exercer, écrivez à contact@loyaris.fr.",
          "Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        ],
      },
    ],
  },
};
